// @flow
import React, { Component } from 'react'
import Scrollchor from 'react-scrollchor'

export class ScrollToTopOnMount extends Component<{}> {
  _back: null

  componentDidMount () {
    if (this._back !== null) this._back.simulateClick()
  }

  render () {
    return (
      <Scrollchor
        ref={ref => (this._back = ref)}
        to='progressbar'
        disableHistory
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/scrollToTop/index.js